module.exports = __webpack_public_path__ + "img/38.e0761494.jpg";